import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import bg22 from "../assets/img/bg22.png";
import contact_feature_1 from "../assets/img/update_2/icon/contact_feature_1.svg";
import contact_feature_2 from "../assets/img/update_2/icon/contact_feature_2.svg";
import contact_feature_3 from "../assets/img/update_2/icon/contact_feature_3.svg";
import contact_feature_4 from "../assets/img/update_2/icon/contact_feature_4.svg";
import Footer from './footer';
import '../assets/css/style.css';
import '../assets/css/slick.min.css';

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    subject: '',
    message: ''
  });

  const [responseMessage, setResponseMessage] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch('https://icedreamglobal.com/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const result = await res.json();

      if (result.success) {
        setResponseMessage("Message sent successfully!");
        setFormData({ name: '', number: '', subject: '', message: '' });
      } else {
        setResponseMessage("Failed to send message. Please try again.");
      }
    } catch (err) {
      setResponseMessage("Something went wrong. Please try again.");
      console.error(err);
    }
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="d-none d-md-block">
        <div id="slider" className="ls-wp-container fitvidsignore hero-6 th-hero-carousel" style={{ margin: '0 auto' }}>
          <div className="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
            <div className="infrastructure-name">
              <div style={{ marginTop: "-40px" }}>
                <ul style={{ listStyleType: 'none', padding: 20 }}>
                  <li>
                    <h1 style={{ fontFamily: 'helvetica', color: "white", margin: 0 }}>CONTACT US</h1>
                  </li>
                  <li>
                    <Link to="/home" style={{ color: 'white', padding: 4 }}>
                      <span className="homeclass" style={{ fontFamily: 'helvetica' }}>Home</span> &nbsp;
                    </Link>
                    <span style={{ color: 'white' }}>
                      &gt; &nbsp;<span className="redname" style={{ fontFamily: 'helvetica', color: '#F0B323' }}>Contact Us</span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <img
              src={bg22}
              className="ls-l ls-img-layer factory"
              alt="background"
              style={{ width: '100%', top: '107px' }}
            />
          </div>
        </div>
      </div>

      {/* Contact Features */}
      <div className="space mt-4 mb-4" style={{ padding: '2rem 0' }}>
        <div className="container">
          <div className="row gy-4" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            {[
              {
                icon: contact_feature_1,
                title: "Factory Address",
                text: "Newryan Global Private Limited, Plot No. 74-75, AKVN, Growth Center, Malanpur, Industrial Area, Bhind-477001, Madhya Pradesh, India"
              },
              {
                icon: contact_feature_4,
                title: "Corporate Office",
                text: "C-8/2 basement and Ground floor, Vasant Vihar near C block Community Center New Delhi - 110057"
              },
              {
                icon: contact_feature_2,
                title: "Email Address",
                text: <a href="mailto:support@icedreamglobal.com">support@icedreamglobal.com</a>
              },
              {
                icon: contact_feature_3,
                title: "Phone Number",
                text: <a href="tel:+919873578910">(+91) 9873578910</a>
              }
            ].map((item, idx) => (
              <div key={idx} className="col-xl-3 col-sm-6" style={{ display: 'flex', flexDirection: 'column', flex: '1 1 25%', minWidth: '200px' }}>
                <div className="contact-feature" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                  <div className="contact-feature_icon">
                    <img src={item.icon} alt="Icon" />
                  </div>
                  <h4 className="box-title" style={{ fontFamily: 'helvetica', color: '#0f1138' }}>{item.title}</h4>
                  <span className="contact-feature_text" style={{ fontFamily: 'helvetica' }}>{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div id="mapSec">
        <div className="contact-map2">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d5096.15147273492!2d78.28951016866098!3d26.350742136296407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDIxJzAxLjQiTiA3OMKwMTcnMjQuMCJF!5e0!3m2!1sen!2sin!4v1757678468518!5m2!1sen!2sin" width="100%" height="200" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>

      {/* Contact Form */}
      <section className="space-bottom contact-form-sec">
        <div className="container">
          <div className="reservation-area">
            <h4 className="sec-title text-center mb-30" style={{ fontFamily: 'helvetica', color: '#0f1138', textTransform: 'uppercase' }}>Send Us Message</h4>

           <form
onSubmit={async (e) => {
e.preventDefault();

const formData = {
name: e.target.name.value,
number: e.target.number.value,
subject: e.target.subject.value,
message: e.target.message.value,
};

try {
const response = await fetch("https://icedreamglobal.com/api.php", {
method: "POST",
headers: {
"Content-Type": "application/json",
},
body: JSON.stringify(formData),
});

const result = await response.json();
if (result.success) {
alert("Message sent successfully!");
e.target.reset();
} else {
alert("Error sending message: " + result.error);
}
} catch (error) {
alert("Something went wrong. Try again later.");
}
}}
className="booking-form3 ajax-contact"
id="sendform"
>
<div className="row">
<div className="form-group col-lg-4 col-md-6">
<input type="text" className="form-control rounded-2" name="name" placeholder="Your Name" />
</div>
<div className="form-group col-lg-4 col-md-6">
<input type="tel" className="form-control rounded-2" name="number" placeholder="Phone Number" />
</div>
<div className="form-group col-lg-4">
<input type="text" className="form-control rounded-2" name="subject" placeholder="Subject" />
</div>
<div className="form-group col-12">
<textarea name="message" cols="30" rows="3" className="form-control rounded-2" placeholder="Write Message"></textarea>
</div>
</div>
<div className="text-center">
<button type="submit" className="th-btn rounded-2" style={{ background: "#F0B323" }}>
Send Message <i className="fa-solid fa-arrow-right ms-2"></i>
</button>
</div>
</form>
         
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contactus;
